document.addEventListener("DOMContentLoaded", function () {
  // Set the end date for the countdown (e.g., Mar 16, 2026, 03:00:00)
  const endDate = new Date("2026-03-16T03:00:00").getTime();

  // Update the countdown every second
  const timer = setInterval(function () {
    const now = new Date().getTime();
    const distance = endDate - now;

    // Time calculations
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result
    document.getElementById("days").innerText = days;
    document.getElementById("hours").innerText = hours;
    document.getElementById("minutes").innerText = minutes;
    document.getElementById("seconds").innerText = seconds;

    // If the countdown is over, stop the timer
    if (distance < 0) {
      clearInterval(timer);
      document.getElementById("countdown-timer").innerText = "The deadline has passed!";
    }
  }, 1000);
});
